import { DEFAULT_VISIBLE_METRICS, PRESET_METRICS } from './analysisMetrics';

const STORAGE_KEY = 'immoIQ.analysis.display.v1';

const DEFAULT_PREFS = {
  visibleMetricIds: DEFAULT_VISIBLE_METRICS,
  showDynamicAssets: false,
  showDynamicRevenues: false,
  activeChartTab: 'netWorth',
  controlsOpen: true,
  detailMode: true,
  /** Tableaux de débogage Analyse (cashflow par actif / par entité) — repliés par défaut. */
  debugTablesOpen: false,
};

export function loadAnalysisDisplayPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return {
      ...DEFAULT_PREFS,
      ...parsed,
      visibleMetricIds: Array.isArray(parsed.visibleMetricIds)
        ? parsed.visibleMetricIds
        : DEFAULT_PREFS.visibleMetricIds,
    };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function saveAnalysisDisplayPrefs(prefs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    /* ignore quota errors */
  }
}

export function applyPreset(presetKey) {
  const ids = PRESET_METRICS[presetKey];
  return ids ? [...ids] : DEFAULT_VISIBLE_METRICS;
}

export { DEFAULT_PREFS, STORAGE_KEY };
